import fs from 'node:fs';
import path from 'node:path';
import os from 'node:os';

/**
 * Path to the CLI code-navigation cache SQLite database (file index + symbol index).
 * Override with `BUILDAMATON_CODE_NAV_CACHE_SQLITE_PATH` for tests or custom layouts.
 * Safe to delete — only caches; the main CLI database is unaffected.
 */
export function getCodeNavCacheSqlitePath(): string {
  const override = process.env.BUILDAMATON_CODE_NAV_CACHE_SQLITE_PATH?.trim();
  if (override) return path.resolve(override);
  return path.join(os.homedir(), '.buildautomaton', 'code-nav-cache.sqlite');
}

export function ensureCodeNavCacheSqliteParentDir(sqlitePath: string): void {
  const dir = path.dirname(sqlitePath);
  if (!fs.existsSync(dir)) fs.mkdirSync(dir, { recursive: true });
}
